module.exports = __webpack_public_path__ + "static/media/Desktop_Summary_13.a8373390.png";